export default __webpack_public_path__ + "static/media/logo_curve.6382a55a.png";